<template>
    <div class="smartphone" :class="isInScrollRange ? 'zoom' : ''">
        <img :src="cover" class="coverPhone pe-none">
        <div class="screen">
            <!-- Chat Header -->
            <div class="chat-header pe-none">
                <div class="back-icon">
                    <svg viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fill="#fff"
                            d="M7.39727345,2.21077392 C7.67341324,1.93425491 8.12633841,1.92915248 8.40891014,2.19937732 C8.69148187,2.46960216 8.69669599,2.91282562 8.4205562,3.18934463 L8.4205562,3.18934463 L2.373,9.244 L19.3043125,9.34868466 C19.6909046,9.35104785 20.0023837,9.66635841 20.0000338,10.0529505 C19.9976573,10.4395426 19.6823467,10.7510217 19.2957546,10.7486719 L2.487,10.645 L8.79010593,16.8045692 C9.04172326,17.0504435 9.06714844,17.4340657 8.86619976,17.7077757 L8.7908324,17.7946019 C8.51165882,18.0681882 8.05870375,18.0685065 7.77912894,17.7953128 L7.77912894,17.7953128 L0.20989415,10.398842 C-0.0675492719,10.127731 -0.0702933194,9.68859574 0.203741272,9.41418482 L0.203741272,9.41418482 Z" />
                    </svg>
                </div>
                <div class="avatar">
                    <img :src="a1" alt="Avatar"/>
                </div>
                <div class="contact-info">
                    <div class="contact-name font-2-1 lh-1 w-100">{{formFields.step2.receiverWhatsapp }}</div>
                    <div class="contact-status lh-1 font-2-1 w-100 mt-sm-1">{{capitalizeWords(formFields.step1.receiverName)}}</div>
                </div>
                <div class="menu-icon me-2 mt-2">⋮</div>
            </div>

            <!-- Chat Messages -->
            <div class="chat-messages" ref="container">
                <div class="w-100 d-flex justify-content-center pe-none">
                    <div class="date-separator font-2-1">Hoy</div>
                </div>
                
                <div class="message received">

                    <span class="shareIcon pe-none">
                        <svg class="iconCircle" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                            <title>share-arrow-solid</title>
                            <g id="Layer_2" data-name="Layer 2">
                              <g id="invisible_box" data-name="invisible box">
                                <rect width="48" height="48" fill="none"/>
                              </g>
                              <g id="Q3_icons" data-name="Q3 icons">
                                <path d="M28.3,6a1.2,1.2,0,0,0-1.1,1.3V17.9C12,19.4,2.2,29.8,2,40.3c0,.6.2,1,.6,1s.7-.3,1.1-1.1c2.4-5.4,7.8-8.5,23.5-9.2v9.7A1.2,1.2,0,0,0,28.3,42a.9.9,0,0,0,.8-.4L45.6,25.1a1.5,1.5,0,0,0,0-2L29.1,6.4a.9.9,0,0,0-.8-.4Z"/>
                              </g>
                            </g>
                        </svg>
                    </span>

                    <svg class="chat-tail pe-none" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#fff">
                        <path d="M0 12 C4 10, 6 6, 12 6 C9 9, 9 12, 12 18 C6 16, 4 14, 0 12 Z" />
                    </svg>

                    <div class="messpad pe-none">
                        <img :src="mW" class="simple-image" />
                        <div class="simple-text text-start d-flex flex-wrap">
                            <span class="mb-2 font-2-1">{{capitalizeWords(formFields.step1.receiverName)}},</span>
                            <span class="font-2-1 bw w-100"><template v-if="formFields.step4.senderName != ''">{{capitalizeWords(formFields.step4.senderName)}}</template><template v-else>Alguien</template> te ha enviado un obsequio especial.</span>
                        </div>
                        <span class="time font-2-1 w-100 d-flex text-end justify-content-end">12:00</span>
                    </div>

                    <div @click="openPresent()" class="simple-button d-flex align-items-center align-content-center justify-content-center lh-1 font-2-1" :class="openGift ? 'pe-none' : 'active'">
                        <svg class="button-icon" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                        <g id="Layer_2" data-name="Layer 2">
                          <g id="invisible_box" data-name="invisible box">
                            <rect width="48" height="48" fill="none"/>
                          </g>
                          <g id="Q3_icons" data-name="Q3 icons">
                            <path d="M16.8,14.2v7.4l3.6.3c7.4.7,13.1,3.7,16.7,7.5C33,28,27.8,27.3,21,27l-4.2-.2v7.1L7,24.1l9.8-9.9M19.7,6a.9.9,0,0,0-.8.4L2.4,23.1a1.5,1.5,0,0,0,0,2L18.9,41.6a.9.9,0,0,0,.8.4,1.2,1.2,0,0,0,1.1-1.3V31c15.7.7,21.1,3.8,23.5,9.2.4.8.8,1.1,1.1,1.1s.6-.4.6-1c-.2-10.5-10-20.9-25.2-22.4V7.3A1.2,1.2,0,0,0,19.7,6Z"/>
                          </g>
                        </g>
                      </svg>Abrir mi obsequio
                      <div class="circle-icon" v-if="!openGift"></div>
                      <div class="circle-icon2" v-if="!openGift"></div>
                      <svg class="cursor-icon" v-if="!openGift" fill="#FF5733" width="50px" height="50px" viewBox="0 0 36 36" version="1.1" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <title>cursor-hand-line</title>
                        <path class="clr-i-outline clr-i-outline-path-1" fill-rule="evenodd" d="M30.74,15.19a13.66,13.66,0,0,0-6.87-3.83A26,26,0,0,0,18,10.58V5.28A3.4,3.4,0,0,0,14.5,2,3.4,3.4,0,0,0,11,5.28v10L9.4,13.7a3.77,3.77,0,0,0-5.28,0A3.67,3.67,0,0,0,3,16.33a3.6,3.6,0,0,0,1,2.56l4.66,5.52a11.53,11.53,0,0,0,1.43,4,10.12,10.12,0,0,0,2,2.54v1.92a1.07,1.07,0,0,0,1,1.08H27a1.07,1.07,0,0,0,1-1.08v-2.7a12.81,12.81,0,0,0,3-8.36v-6A1,1,0,0,0,30.74,15.19ZM29,21.86a10.72,10.72,0,0,1-2.6,7.26,1.11,1.11,0,0,0-.4.72V32H14.14V30.52a1,1,0,0,0-.44-.83,7.26,7.26,0,0,1-1.82-2.23,9.14,9.14,0,0,1-1.2-3.52,1,1,0,0,0-.23-.59L5.53,17.53a1.7,1.7,0,0,1,0-2.42,1.76,1.76,0,0,1,2.47,0l3,3v3.14l2-1V5.28A1.42,1.42,0,0,1,14.5,4,1.42,1.42,0,0,1,16,5.28v11.8l2,.43V12.59a24.27,24.27,0,0,1,2.51.18V18l1.6.35V13c.41.08.83.17,1.26.28a14.88,14.88,0,0,1,1.53.49v5.15l1.6.35V14.5A11.06,11.06,0,0,1,29,16.23Z"></path>
                    </svg>
                    
                    </div>
                </div>

                <div class="message sent pe-none" v-show="openGift" id="mess2">

                    <svg class="chat-tail" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#DBF8D4">
                        <path d="M0 12 C4 10, 6 6, 12 6 C9 9, 9 12, 12 18 C6 16, 4 14, 0 12 Z" />
                    </svg>

                    <div class="messpad">
                        <div class="messForward d-flex">
                            <div class="barColor"></div>
                            <span class="messContent d-flex flex-wrap h-100 col-10">
                                <span class="messHeader d-flex h-25 w-100">
                                    <span class="messNumber">+1 (555) 102-7083</span>
                                    <span class="messNick">~15551027083</span>
                                </span>
                                <span class="messText h-75">
                                    {{capitalizeWords(formFields.step1.receiverName)}}, <br><br>{{capitalizeWords(formFields.step4.senderName)}} te ha enviado un obsequio especial.
                                </span>
                            </span>
                            <span class="messMedia d-flex h-100 col-2">
                                <img :src="mW" class="simple-image"/>
                            </span>
                        </div>
                        <div class="simple-text text-start d-flex flex-wrap pb-0">
                            Abrir mi obsequio
                        </div>
                        <span class="time font-2-1 w-100 d-flex text-end justify-content-end">12:00</span>
                    </div>

                </div>

                <div class="message received pe-none" v-show="catchGift" id="mess3">

                    <svg class="chat-tail" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#fff">
                        <path d="M0 12 C4 10, 6 6, 12 6 C9 9, 9 12, 12 18 C6 16, 4 14, 0 12 Z" />
                    </svg>

                    <span class="shareIcon">
                        <svg class="iconCircle" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                            <title>share-arrow-solid</title>
                            <g id="Layer_2" data-name="Layer 2">
                              <g id="invisible_box" data-name="invisible box">
                                <rect width="48" height="48" fill="none"/>
                              </g>
                              <g id="Q3_icons" data-name="Q3 icons">
                                <path d="M28.3,6a1.2,1.2,0,0,0-1.1,1.3V17.9C12,19.4,2.2,29.8,2,40.3c0,.6.2,1,.6,1s.7-.3,1.1-1.1c2.4-5.4,7.8-8.5,23.5-9.2v9.7A1.2,1.2,0,0,0,28.3,42a.9.9,0,0,0,.8-.4L45.6,25.1a1.5,1.5,0,0,0,0-2L29.1,6.4a.9.9,0,0,0-.8-.4Z"/>
                              </g>
                            </g>
                        </svg>
                    </span>

                    <div class="messpad">
                        <design-list :formFields="formFields" fit="true"></design-list>
                        <div class="simple-text text-start d-flex flex-wrap" v-if="formFields.step2.receiverMessage != ''">
                            <span class="mb-2 font-2-1">Este obsequio también incluye un mensaje:</span>
                            <span class="font-2-1 bw w-100">{{formFields.step2.receiverMessage}}</span>
                        </div>
                        <span class="time font-2-1 w-100 d-flex text-end justify-content-end">12:00</span>
                    </div>
                </div>

            </div>

            <!-- Chat Footer -->
            <div class="chat-footer pe-none">
                <div class="input-container">
                    <div class="icon emoji-icon"><svg class="icon-footer" width="20px" height="20px" viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg">
                            <path fill="#89959C"
                                d="M10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 Z M10,1.39534884 C5.24778239,1.39534884 1.39534884,5.24778239 1.39534884,10 C1.39534884,14.7522176 5.24778239,18.6046512 10,18.6046512 C14.7522176,18.6046512 18.6046512,14.7522176 18.6046512,10 C18.6046512,5.24778239 14.7522176,1.39534884 10,1.39534884 Z M7.74358499,11.9992836 C7.8796076,13.1337478 8.84672907,13.9977416 10,13.9977416 C11.1476397,13.9977416 12.1116922,13.1419649 12.2545505,12.014406 C12.3018808,11.6408346 12.6430891,11.376364 13.0166605,11.4236943 C13.3902319,11.4710247 13.6547026,11.812233 13.6073722,12.1858044 C13.378445,13.9926929 11.8365892,15.361378 10,15.361378 C8.15440149,15.361378 6.60761388,13.9795299 6.38964607,12.1616213 C6.34481775,11.7877414 6.61156677,11.4483113 6.98544668,11.403483 C7.35932659,11.3586547 7.69875667,11.6254037 7.74358499,11.9992836 Z M5.81395349,6.27906977 C6.58458337,6.27906977 7.20930233,6.90378872 7.20930233,7.6744186 C7.20930233,8.44504849 6.58458337,9.06976744 5.81395349,9.06976744 C5.0433236,9.06976744 4.41860465,8.44504849 4.41860465,7.6744186 C4.41860465,6.90378872 5.0433236,6.27906977 5.81395349,6.27906977 Z M14.1860465,6.27906977 C14.9566764,6.27906977 15.5813953,6.90378872 15.5813953,7.6744186 C15.5813953,8.44504849 14.9566764,9.06976744 14.1860465,9.06976744 C13.4154166,9.06976744 12.7906977,8.44504849 12.7906977,7.6744186 C12.7906977,6.90378872 13.4154166,6.27906977 14.1860465,6.27906977 Z" />
                        </svg></div>
                    <input type="text" class="footer-input" placeholder="Mensaje" />
                    <div class="icon clip-icon"><svg class="icon-footer" width="20px" height="20px" viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg">
                            <path fill="#89959C"
                                d="M3.26370324,8.57901468 C2.99453017,8.85144476 2.55815971,8.85139888 2.28904255,8.5789122 C2.01992538,8.30642553 2.0199707,7.86468321 2.28914377,7.59225313 L8.31841803,1.49869904 C9.6814954,0.444085855 11.0494163,-0.0634259367 12.4102348,0.00632825194 C14.1258309,0.0942679855 15.4624193,0.748186494 16.5955255,1.82083609 C17.7517135,2.91533596 18.5,4.4761857 18.5,6.36786284 C18.5,7.82020638 18.0777556,9.09825417 17.1873382,10.2322297 L8.68369766,18.992369 C7.82306461,19.6971651 6.86800034,20.0383772 5.84464483,19.9965751 C4.54447205,19.9434657 3.57689721,19.5225003 2.85751064,18.812055 C2.01566307,17.9806708 1.5,16.9595407 1.5,15.586809 C1.5,14.4947997 1.87673374,13.4871176 2.65464506,12.5414674 L10.1390133,4.89886776 C10.7397414,4.25929091 11.3262525,3.87857385 11.9260788,3.78745695 C12.7592435,3.66089468 13.5630715,3.94799237 14.125324,4.54188726 C14.6582899,5.10484729 14.8863791,5.80668361 14.8061508,6.60631594 C14.7514821,7.15119754 14.5282081,7.65301591 14.1180011,8.13362927 L7.23878241,15.1818274 C6.97126126,15.4559198 6.5348987,15.4585772 6.26413935,15.1877628 C5.99338001,14.9169484 5.99075494,14.475214 6.25827609,14.2011216 L13.1050596,7.18854878 C13.3043212,6.95383296 13.4095414,6.71734597 13.4348274,6.46532072 C13.4749133,6.06578671 13.3787672,5.76994273 13.1301718,5.507357 C12.8740282,5.23679814 12.515784,5.10884654 12.1306257,5.16735419 C11.8867692,5.20439732 11.5466923,5.42514859 11.1279193,5.87078347 L3.67468228,13.4778958 C3.13824791,14.1329762 2.87837838,14.8280715 2.87837838,15.586809 C2.87837838,16.5407878 3.22343307,17.2240746 3.82004074,17.813267 C4.29545562,18.2827729 4.93985667,18.5631342 5.9002189,18.6023631 C6.57923469,18.6300995 7.20937629,18.4049713 7.75849029,17.9611447 L16.1548885,9.3108071 C16.800384,8.48404341 17.1216216,7.51172274 17.1216216,6.36786284 C17.1216216,4.88582368 16.545304,3.68368344 15.6540647,2.83999601 C14.743984,1.97847246 13.7042594,1.46979297 12.340529,1.39988952 C11.3332737,1.34825863 10.2755553,1.74068233 9.22420262,2.5463929 L3.26370324,8.57901468 Z" />
                        </svg></div>
                    <div class="icon camera-icon">
                        <svg class="icon-footer" width="20px" height="20px" viewBox="0 -2 32 32">
                            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
                                sketch:type="MSPage">
                                <g id="Icon-Set-Filled" sketch:type="MSLayerGroup"
                                    transform="translate(-258.000000, -467.000000)" fill="#89959C">
                                    <path
                                        d="M286,471 L283,471 L282,469 C281.411,467.837 281.104,467 280,467 L268,467 C266.896,467 266.53,467.954 266,469 L265,471 L262,471 C259.791,471 258,472.791 258,475 L258,491 C258,493.209 259.791,495 262,495 L286,495 C288.209,495 290,493.209 290,491 L290,475 C290,472.791 288.209,471 286,471 Z M274,491 C269.582,491 266,487.418 266,483 C266,478.582 269.582,475 274,475 C278.418,475 282,478.582 282,483 C282,487.418 278.418,491 274,491 Z M274,477 C270.687,477 268,479.687 268,483 C268,486.313 270.687,489 274,489 C277.313,489 280,486.313 280,483 C280,479.687 277.313,477 274,477 L274,477 Z"
                                        id="camera" sketch:type="MSShapeGroup">
                                    </path>
                                </g>
                            </g>
                        </svg>
                    </div>
                </div>
                <div class="icon send-icon">
                    <svg class="icon-footer" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M12 2a3 3 0 0 0-3 3v7a3 3 0 1 0 6 0V5a3 3 0 0 0-3-3zM5 12a1 1 0 1 1 2 0 5 5 0 0 0 10 0 1 1 0 1 1 2 0 7.001 7.001 0 0 1-6 6.93V21a1 1 0 1 1-2 0v-2.07A7.001 7.001 0 0 1 5 12z"
                            fill="#fff" />
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import designList from '@/components/designList.vue'
export default {
    name: "WhatsAppChat",
    components:{
        designList
    },
    props: {
        formFields: {},
    },
    methods: {
        openPresent(){
            this.openGift = true;
        },
        toScroll(elm){
            let node = this.$refs.container;
            node.scrollTo({
                top: elm.offsetHeight,
                behavior: 'smooth', // O 'auto' para un desplazamiento instantáneo
            });
        },
        handleScroll() {
            if (window.innerWidth < 576 && this.node) {
                const scrollPosition = this.node.scrollTop; // Posición actual del scroll dentro del div
                const totalHeight = this.node.scrollHeight - this.node.clientHeight; // Altura total del contenido del div menos la altura visible
                const scrollPercentage = (scrollPosition / totalHeight) * 100;

                // Cambia la variable según el rango
                this.isInScrollRange = scrollPercentage >= 0 && scrollPercentage <= 30;
            } else {
                // Si no es móvil o no existe el div, asegura que el valor esté en false
                this.isInScrollRange = false;
            }
        },  
        runAnimation(){
            setTimeout(()=>{
                if(!this.openGift){
                    this.openGift = true;
                }
            }, 3000)

            setTimeout(()=>{
                this.openGift = false;
                this.catchGift = false;
                setTimeout(()=>{
                    this.runAnimation();
                }, 100)
            }, 8000)
        },
    },
    watch:{
        catchGift(){
            if(this.catchGift){
                setTimeout(()=>{
                    let node = document.getElementById('mess3');
                    this.toScroll(node);
                }, 100)
            }
        },
        openGift(){
            if(this.openGift){
                setTimeout(()=>{
                    let node = document.getElementById('mess2');
                    this.toScroll(node);
                }, 1000)
            }
            setTimeout(()=>{
                if(!this.openGift){
                    this.catchGift = false;
                }else{
                    this.catchGift = true;
                }
            }, 2000)
        }
    },
    mounted(){
        this.node = document.getElementById('masterComponent');
        this.node.addEventListener('scroll', this.handleScroll);
        this.handleScroll();
        this.runAnimation();
    },
    beforeUnmount() {
        // Elimina el evento de scroll
        this.node.removeEventListener('scroll', this.handleScroll);
    },
    data() {
        return {
            catchGift:false,
            node: document.getElementById('masterComponent'),
            openGift:false,
            isInScrollRange: false,
            mW:require('@/assets/images/franchise/bpt/messWhatsapp.jpg'),
            a1:require('@/assets/images/a1.jpg'),
            cover: require('@/assets/images/cover.png')
        }
    }
};
</script>

<style scoped>
/* Smartphone container */
.smartphone {
    transform-origin: 50% 0%;
    transition: all 0.5s ease;
    position: relative;
    background: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    z-index: 1000;
}

/* Screen */
.screen {
    width: 95%;
    height: 98%;
    display: flex;
    flex-direction: column;
    background: #eaeaea;
    overflow: hidden;
}

/* Chat header */
.chat-header {
    background: #075e54;
    color: #fff;
    display: flex;
    align-items: center;
}

.back-icon {
    margin-right: 10px;
    cursor: pointer;
}

.avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 10px;
    flex-shrink: 0;
}

.avatar img {
    width: 100%;
    height: 100%;
    flex-shrink: 0;
    border-radius: 50%;
    object-fit: contain;
}

.contact-info {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    justify-content: flex-start;
    text-align: left;
    font-weight: bold;
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.contact-name {
    font-weight: bold;
    max-width:85%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.contact-status {
    color: #d0f8ce;
}

.menu-icon {
    cursor: pointer;
}

/* Chat messages */
.chat-messages {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: scroll;
    background: #e5ddd5;
    scrollbar-width: thin; /* Para navegadores Firefox: estilo delgado */
    scrollbar-color: rgba(0, 0, 0, 0.3) transparent; /* Para navegadores Firefox */
}

/* Estilo para navegadores basados en WebKit (Chrome, Edge, Safari) */
.chat-messages::-webkit-scrollbar {
    width: 8px; /* Ancho de la barra */
  }
  
  .chat-messages::-webkit-scrollbar-track {
    background: transparent; /* Fondo del track */
    border-radius: 6px; /* Redondea el fondo del track */
  }
  
  .chat-messages::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.3); /* Color del pulgar */
    border-radius: 6px; /* Bordes redondeados */
  }
  
  .chat-messages::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.5); /* Color más oscuro al pasar el mouse */
  }
  
  .chat-messages::-webkit-scrollbar-button {
    display: none; /* Oculta las flechas arriba y abajo */
  }
  

.date-separator {
    text-align: center;
    color: #9A9D9A;
    background: #F6F6F3;
    border-radius: 10px;
}

.message {
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    position: relative;
    opacity: 0;
    animation:appendMes 1s ease 1 forwards;
}

@keyframes appendMes {
    0%{
        opacity: 0;
    }
    100%{
        opacity: 1;
    }
}

.message span.text {
    margin-bottom: 5px;
}

.message span.time {
    color: #666;
    align-self: flex-end;
}

.message.received {
    background: #fff;
    align-self: flex-start;
    border-radius: 7px 7px 7px 0;
    z-index: 100;
}

.message.sent {
    background: #DBF8D4;
    align-self: flex-end;
    border-radius: 7px 7px 0 7px;
    z-index: 50;
}


/* Card message */

.simple-image {
    width: 100%;
    height: auto;
    object-fit: cover;
    border-radius: 7px;
}

.message.received .simple-text {
    color: #333;
}
.message.sent .simple-text {
    color: #333;
}

.simple-text {
    color: #333;
    display: flex;
    text-align: left;
    justify-content: flex-start;
}

.simple-button {
    border-top:1px solid #ccc;
    color: #ccc;
    text-align: center;
    cursor: pointer;
    position: relative;
    perspective: 800px;
    transform-style: preserve-3d;
}

.simple-button.active{
    color: #333;
}

/* Chat footer */
.chat-footer {
    background: #f0f0f0;
    display: flex;
    align-items: center;
    border-top: 1px solid #ccc;
}

.input-container {
    display: flex;
    align-items: center;
    background: #fff;
    border: 1px solid #ccc;
}

.input-container input {
    width: 100%;
    border: none;
    outline: none;
    line-height: 0
}

.input-container .icon {
    margin: 0 5px;
    cursor: pointer;
    line-height: 0
}

.send-icon {
    margin-left: 7px;
    cursor: pointer;
    border-radius: 50%;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    background-color: #15A883;
}

.coverPhone {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0%;
    top: 0%;
    z-index: 20;
    pointer-events: none;
}


.zoom{
    transform: scale(1.5);
}


@media (min-width: 0px) {
    .smartphone{
        width: 190px;
        height: 400px;
        border-radius: 0px;
    }
    .chat-header {
        background: #075e54;
        padding-left: 5px;
        padding-right: 5px;
        padding-top: 8%;
        padding-bottom: 2%
    }
    .avatar {
        width: 30px;
        height: 30px;
    }
    .contact-name{
        font-size: 45%;
    }
    .contact-status{
        font-size: 35%;
    }
    .back-icon svg{
        margin-left: 2px;
        width: 10px;
        height: 10px;
    }
    .menu-icon{
        font-size: 80%;
    }
    
    .date-separator {
        margin: 0 0 5px 0;
        padding: 4px 0;
        width: 18%;
        font-size: 30%;
    }

    .chat-messages {
        padding: 5px;
    }
    .message {
        max-width: 75%;
        margin-bottom: 10px;
        padding: 0;
    }
    .messpad{
        width: 100%;
        padding: 2px 2px;
        display: flex;
        flex-direction: column;
        position: relative;
    }
    .simple-text {
        padding: 5px;
        font-size: 50%;
    }
    .simple-button {
        font-size: 50%;
        padding: 7px 8px;
    }

    .message span.time {
        font-size: 40%;
        padding-right: 5px
    }

    .button-icon{
        width: 9px;
        height: 9px;
        margin-right: 3%;
    }
    .button-icon path{
        fill: #ccc;
    }

    .circle-icon, .circle-icon2{
        border-radius: 50%;
        border:2px solid var(--secondary);
        height: 50px;
        left: 34%;
        transform: scale(0);
        animation: increasing 1s linear infinite;
        position: absolute;
        width: 50px;
        pointer-events: none;
        z-index: 1000;
    }

    .circle-icon{
        animation-delay: 2.1s;
    }
    .circle-icon2{
        animation-delay: 2.3s;
    }

    .cursor-icon{
        position: absolute;
        width: auto;
        left: 40%;
        height: 100%;
        margin-right: 3%;
        top: 25%;
        pointer-events: none;
        animation: click 3s ease-out 1 forwards;
        transform-style: preserve-3d;
    }
    .cursor-icon path{
        fill: var(--secondary);
    }

    .messForward{
        height: 50px;
    }
    .messNumber{
        font-size: 45%;
    }
    .messNick{
        font-size: 40%;
    }
    .messText{
        font-size: 35%;
    }


    .chat-footer {
        padding: 3% 2px 4% 5px;
    }
    .icon-footer{
        height: 12px;
        width:12px;
    }
    .input-container input {
        padding: 4%;
        font-size: 55%;
    } 
    .input-container {
        width: calc(100% - 40px);
        border-radius: 20px;
        padding: 4px 5px;
    } 
   
    .send-icon {
        width: 30px;
        height: 30px;
        padding: 5px;
    }
}


@media (min-width: 576px) {
    .smartphone{
        width: 350px;
        height: 690px;
        border-radius: 30px;
    }
    .chat-header {
        background: #075e54;
        padding-left: 5px;
        padding-right: 5px;
        padding-top: 10%;
        padding-bottom: 3%
    }
    .avatar {
        width: 35px;
        height: 35px;
    }
    .contact-name{
        font-size: 75%;
    }
    .contact-status{
        font-size: 65%;
    }
    .back-icon svg{
        margin-left: 5px;
        width: 15px;
        height: 15px;
    }
    .menu-icon{
        font-size: 145%;
    }
    
    .date-separator {
        margin: 0 0 5px 0;
        padding: 4px 0;
        width: 18%;
        font-size: 60%;
    }

    .chat-messages {
        padding: 5px;
    }
    .message {
        max-width: 75%;
        margin-bottom: 10px;
        padding: 0;
    }
    .messpad{
        width: 100%;
        padding: 2px 2px;
        display: flex;
        flex-direction: column;
        position: relative;
    }
    .simple-text {
        padding: 5px;
        font-size: 100%;
    }
    .simple-button {
        font-size: 90%;
        padding: 15px 8px;
    }

    .message span.time {
        font-size: 70%;
        padding-right: 5px
    }

    .button-icon{
        width: 15px;
        height: 15px;
        margin-right: 3%;
    }
    .button-icon path{
        fill: #ccc;
    }

    .messForward{
        height: 90px;
    }
    .messNumber{
        font-size: 95%;
    }
    .messNick{
        font-size: 80%;
    }
    .messText{
        font-size: 65%;
    }


    .chat-footer {
        padding: 4% 3px 5% 10px;
    }
    .icon-footer{
        height: 25px;
        width:25px;
    }
    .input-container input {
        padding: 4%;
        font-size: 95%;
    } 
    .input-container {
        width: calc(100% - 55px);
        border-radius: 20px;
        padding: 4px 5px;
    } 
   
    .send-icon {
        width: 40px;
        height: 40px;
        padding: 8px;
    }
}

@media (min-width: 768px) {
    .smartphone{
        width: 350px;
        height: 690px;
        border-radius: 30px;
    }
    .chat-header {
        background: #075e54;
        padding-left: 5px;
        padding-right: 5px;
        padding-top: 10%;
        padding-bottom: 3%
    }
    .avatar {
        width: 35px;
        height: 35px;
    }
    .contact-name{
        font-size: 75%;
    }
    .contact-status{
        font-size: 65%;
    }
    .back-icon svg{
        margin-left: 5px;
        width: 15px;
        height: 15px;
    }
    .menu-icon{
        font-size: 145%;
    }
    
    .date-separator {
        margin: 0 0 5px 0;
        padding: 4px 0;
        width: 18%;
        font-size: 60%;
    }

    .chat-messages {
        padding: 5px;
    }
    .message {
        max-width: 75%;
        margin-bottom: 10px;
        padding: 0;
    }
    .messpad{
        width: 100%;
        padding: 2px 2px;
        display: flex;
        flex-direction: column;
        position: relative;
    }
    .simple-text {
        padding: 5px;
        font-size: 100%;
    }
    .simple-button {
        font-size: 90%;
        padding: 15px 8px;
    }

    .message span.time {
        font-size: 70%;
        padding-right: 5px
    }

    .button-icon{
        width: 15px;
        height: 15px;
        margin-right: 3%;
    }
    .button-icon path{
        fill: #ccc;
    }

    .messForward{
        height: 90px;
    }
    .messNumber{
        font-size: 95%;
    }
    .messNick{
        font-size: 80%;
    }
    .messText{
        font-size: 65%;
    }


    .chat-footer {
        padding: 4% 3px 5% 10px;
    }
    .icon-footer{
        height: 25px;
        width:25px;
    }
    .input-container input {
        padding: 4%;
        font-size: 95%;
    } 
    .input-container {
        width: calc(100% - 55px);
        border-radius: 20px;
        padding: 4px 5px;
    } 
   
    .send-icon {
        width: 40px;
        height: 40px;
        padding: 8px;
    }
}
@media (min-width: 992px) {
    .smartphone{
        width: 360px;
        height: 740px;
        border-radius: 30px;
    }
    .chat-header {
        background: #075e54;
        padding-left: 5px;
        padding-right: 5px;
        padding-top: 10%;
        padding-bottom: 2%
    }
    .avatar {
        width: 35px;
        height: 35px;
    }
    .contact-name{
        font-size: 75%;
    }
    .contact-status{
        font-size: 65%;
    }
    .back-icon svg{
        margin-left: 5px;
        width: 15px;
        height: 15px;
    }
    .menu-icon{
        font-size: 145%;
    }
    
    .date-separator {
        margin: 0 0 5px 0;
        padding: 4px 0;
        width: 18%;
        font-size: 60%;
    }

    .chat-messages {
        padding: 5px;
    }
    .message {
        max-width: 75%;
        margin-bottom: 10px;
        padding: 0;
    }
    .messpad{
        width: 100%;
        padding: 2px 2px;
        display: flex;
        flex-direction: column;
        position: relative;
    }
    .simple-text {
        padding: 5px;
        font-size: 100%;
    }
    .simple-button {
        font-size: 90%;
        padding: 15px 8px;
    }

    .message span.time {
        font-size: 70%;
        padding-right: 5px
    }

    .button-icon{
        width: 15px;
        height: 15px;
        margin-right: 3%;
    }
    .button-icon path{
        fill: #ccc;
    }

    .messForward{
        height: 90px;
    }
    .messNumber{
        font-size: 95%;
    }
    .messNick{
        font-size: 80%;
    }
    .messText{
        font-size: 65%;
    }


    .chat-footer {
        padding: 4% 3px 5% 3px;
    }
    .icon-footer{
        height: 15px;
        width:15px;
    }
    .input-container input {
        padding: 3%;
        font-size: 65%;
    } 
    .input-container {
        width: calc(100% - 50px);
        border-radius: 20px;
        padding: 4px 5px;
    } 
   
    .send-icon {
        width: 30px;
        height: 30px;
        padding: 10px;
    }
}
@media (min-width: 1200px) {
    .smartphone{
        width: 182px;
        height: 358px;
        border-radius: 30px;
    }
    .avatar {
        width: 25px;
        height: 25px;
    }
    .contact-name{
        font-size: 50%;
    }
    .contact-status{
        font-size: 40%;
    }
    .back-icon svg{
        width: 10px;
        height: 10px;
    }
    .chat-header {
        background: #075e54;
        padding-left: 5px;
        padding-right: 5px;
        padding-top: 7%;
        padding-bottom: 2%
    }
    
    .date-separator {
        margin: 0 0 5px 0;
        padding: 2px 0;
        width: 18%;
        font-size: 30%;
    }

    .chat-messages {
        padding: 5px;
    }

    .message {
        max-width: 75%;
        margin-bottom: 10px;
        padding: 0;
    }
    .messpad{
        width: 100%;
        padding: 2px 2px;
        display: flex;
        flex-direction: column;
        position: relative;
    }
    .simple-text {
        padding: 5px;
        font-size: 50%;
    }
    .simple-button {
        font-size: 40%;
        padding: 10px 8px;
    }

    .message span.time {
        font-size: 40%;
    }

    .button-icon{
        width: 10px;
        height: 10px;
        margin-right: 3%;
    }
    .button-icon path{
        fill: #ccc;
    }

    .messForward{
        height: 50px;
    }
    .messNumber{
        font-size: 45%;
    }
    .messNick{
        font-size: 40%;
    }
    .messText{
        font-size: 35%;
    }


    .chat-footer {
        padding: 4% 3px 5% 3px;
    }
    .icon-footer{
        height: 10px;
        width:10px;
    }
    .input-container input {
        padding: 2%;
        font-size: 65%;
    } 
    .input-container {
        width: calc(100% - 50px);
        border-radius: 20px;
        padding: 4px 5px;
    } 
   
    .send-icon {
        width: 30px;
        height: 30px;
        padding: 10px;
    }
}
@media (min-width: 1400px) {
    .smartphone{
        width: 300px;
        height: 610px;
        border-radius: 30px;
    }
    .contact-name{
        font-size: 80%;
    }
    .contact-status{
        font-size: 60%;
    }
    .back-icon svg{
        width: 15px;
        height: 15px;
    }
    .chat-header {
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 10%;
        padding-bottom: 4% 
    }
    .chat-footer {
        padding: 4% 10px 6% 10px;
    }
    .icon-footer{
        height: 20px;
        width:20px;
    }  
    .input-container input {
        padding: 5px;
        font-size: 65%;
    }
    .input-container {
        width: calc(100% - 50px);
        border-radius: 20px;
        padding: 8px 10px;
    }  
    .send-icon {
        width: 40px;
        height: 40px;
        padding: 10px;
    }
    .date-separator {
        margin: 0 0 10px 0;
        padding: 2px 0;
        width: 18%;
        font-size: 50%;
    }
    .chat-messages {
        padding: 10px;
    }
    .message {
        max-width: 75%;
        margin-bottom: 10px;
        padding: 0;
    }
    .messpad{
        width: 100%;
        padding: 2px 2px;
        display: flex;
        flex-direction: column;
        position: relative;
    }
    .simple-text {
        padding: 5px;
        font-size: 70%;
    }
    .simple-button {
        font-size: 70%;
        padding: 10px 8px;
    }
    .message span.time {
        font-size: 60%;
        padding-right: 2%
    }
    .button-icon{
        width: 15px;
        height: 15px;
        margin-right: 3%;
    }
    .button-icon path{
        fill: #ccc;
    }

    .messForward{
        height: 70px;
    }

    .messNumber{
        font-size: 75%;
    }
    .messNick{
        font-size: 55%;
    }
    .messText{
        font-size: 55%;
    }
}
.shareIcon{
    position: absolute;
    left: 105%;
    top: 15%;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    background-color: #ccc;
}
.iconCircle{
    height: 50%;
    width: 50%;
}

.iconCircle path{
    fill: #fff;
}

.messForward{
    background-color: #cdf2bf;
    display: flex;
    border-radius: 7px;
    overflow: hidden;
    width: 100%;
}
.messContent{
    padding-left: 5px;
}
.messHeader{
    overflow: hidden;
}
.messNumber, .messNick{
    align-items: center;
    align-content: center;
    display: inline-flex;
    white-space: nowrap;
}
.messNumber{
    flex-shrink: 0;
    font-weight: bold;
    color: #6ED8AD;
    margin-right: 5px;
}
.messNick{
    width: 100%;
    flex-shrink: 1;
    color: #A2B2AA;
    text-overflow: ellipsis;
}
.messText{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
    text-align: left;
    color: #A2B2AA
}
.messMedia{
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    text-align: center;
    overflow: hidden;
}
.messMedia .simple-image{
    width: auto;
    padding: 0 !important;
    height: 100%;
    object-position: 50% 50%;
    object-fit: cover;
    border-radius: 7px;
}
.barColor{
    height: 100%;
    flex-shrink: 0;
    width: 3px;
    background-color: #6ED8AD;
}
.received .chat-tail {
    position: absolute;
    bottom: -7px; /* Ajusta la posición vertical */
    left: -7px; /* Ajusta la posición horizontal */
    transform: rotateZ(135deg) rotateY(180deg);/* Rota si necesitas una dirección diferente */
}

.sent .chat-tail {
    position: absolute;
    bottom: -7px; /* Ajusta la posición vertical */
    right: -7px; /* Ajusta la posición horizontal */
    transform: rotateZ(45deg) rotateX(180deg) rotateY(180deg);/* Rota si necesitas una dirección diferente */
}

.pe-none{
    user-select: none;
}

.bw{
    word-wrap: break-word;
}


@keyframes click {
    0%{
        transform: translate(0px, 0px);
    }
    10%{
        transform: translate(20px, 10px) scale(1.5);
    }
    20%{
        transform: translate(25px, 15px) scale(1);
    }
    40%{
        transform: translate(-25px, 25px);
    }
    50%{
        transform: translate(0px, 25px) scale(1.5);
    }
    70%{
        transform: translate(0px, 0px);
    }
    75%{
        transform: skewX(0deg) scale(1);
    }
    75%{
        transform: skewX(25deg) scale(0.8) rotateX(60deg);
    }
    100%{
        transform: skewX(0deg) scale(1);
    }
    
}

@keyframes increasing {
    0%{
        transform: scale(0);
        opacity: 0;
    }
    50%{
        transform: scale(2.5);
        opacity: 1;
    }
    60%{
        transform: scale(2.5);
        opacity: 0;
    }
    100%{
        transform: scale(0);
    }
    
}
</style>